const actionTypeIdentifier = 'FB6912C0-3B3E-45AE-BF5E-E631CBA5F474';

export const getVendorDetails  = `CHARGE-MAPPING-GET-Vendor-DETAILS-${actionTypeIdentifier}`;
export const getChargeMappingUploadTypes = `CHARGE-MAPPING-GET-UPLOAD-TYPE-${actionTypeIdentifier}`;
export const setChargeMappingUploadError = `CHARGE-MAPPING-SET-UPLOAD-ERROR-${actionTypeIdentifier}`;

export const ChargeMappingModel = {
    vendorId:0,
    chargeMappingUploadTypeId:0,
    extractError: false,
    files: []
}